/* divos.lt — prekės puslapis, dovanų kuponas, rekomendacijos, neseniai žiūrėtos */
(function () {
  if (window.__divosProductJs) return;
  window.__divosProductJs = true;

  const T = () => window.theme || {};
  const money = c => (T().formatMoney ? T().formatMoney(c) : (c / 100).toFixed(2).replace('.', ',') + ' €');
  const moneyShort = c => money(c).replace(/[.,]00(?=\D*$)/, '');
  const root = () => (T().routes && T().routes.root) || '/';
  const errText = e => (e && (e.description || e.message)) || (typeof e === 'string' ? e : 'Nepavyko įdėti į krepšelį. Bandykite dar kartą.');

  // Įdėjimas į krepšelį (per DivosCart, o jei jo nėra – tiesiogiai per Shopify AJAX API)
  function cartAdd(items, opts) {
    if (window.DivosCart && window.DivosCart.add) return window.DivosCart.add(items, opts);
    const url = ((T().routes && T().routes.cartAdd) || '/cart/add') + '.js';
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) })
      .then(r => r.json().then(j => { if (!r.ok || j.status) throw j; return j; }));
  }
  function done(btn, text) {
    if (!btn) return;
    const old = btn.dataset.label || btn.textContent;
    btn.dataset.label = old;
    btn.textContent = text || 'Įdėta ✓';
    btn.classList.add('done');
    clearTimeout(btn._t);
    btn._t = setTimeout(() => { btn.textContent = old; btn.classList.remove('done'); }, 1500);
  }
  const checkoutUrl = () => root().replace(/\/$/, '') + '/checkout';
  const parse = html => new DOMParser().parseFromString(html, 'text/html');

  /* ---------------- Prekės puslapis ---------------- */
  function initProduct(sec) {
    if (sec.dataset.ready) return;
    sec.dataset.ready = '1';
    const vEl = sec.querySelector('[data-variants]');
    if (!vEl) return;
    const variants = JSON.parse(vEl.textContent);
    const meta = JSON.parse((sec.querySelector('[data-product-meta]') || {}).textContent || '{}');
    const form = document.getElementById(sec.dataset.form);
    const idInput = form && form.querySelector('[data-variant-input]');
    const addBtn = form && form.querySelector('[data-add-to-cart]');
    const errEl = form && form.querySelector('[data-error]');
    const qtyInput = form && form.querySelector('[data-qty-input]');
    const picker = sec.querySelector('[data-variant-picker]');
    const groups = picker ? [...picker.querySelectorAll('.sizes')] : [];
    const labels = picker ? [...picker.querySelectorAll('[data-opt-label]')] : [];
    const sticky = sec.querySelector('[data-sticky-buy]');
    const stickyBtn = sec.querySelector('[data-sticky-add]');
    let current = variants.find(v => idInput && String(v.id) === idInput.value) || variants[0];

    const selected = () => groups.map(g => { const b = g.querySelector('.size.on'); return b ? b.dataset.value : null; });
    const findVariant = opts => variants.find(v => v.options.every((o, i) => o === opts[i]));

    function markAvailability() {
      const sel = selected();
      groups.forEach((g, i) => {
        g.querySelectorAll('.size').forEach(b => {
          const opts = sel.slice(); opts[i] = b.dataset.value;
          const ok = variants.some(v => v.available && v.options.every((o, k) => k === i ? o === opts[i] : (k > i ? true : o === opts[k])));
          b.classList.toggle('is-out', !ok);
        });
      });
    }

    function showMedia(id) {
      if (!id) return;
      const pm = sec.querySelector(`.pm[data-media-id="${id}"]`);
      if (!pm) return;
      sec.querySelectorAll('.pm').forEach(x => x.classList.toggle('on', x === pm));
      sec.querySelectorAll('.thumb').forEach(t => t.classList.toggle('on', t.dataset.mediaId === String(id)));
    }

    function render(v) {
      const priceEl = sec.querySelector('[data-price]');
      const stock = sec.querySelector('[data-stock]');
      const buy = sec.querySelector('[data-buy]');
      const buyNow = sec.querySelector('[data-buy-now]');
      const notify = sec.querySelector('[data-notify]');
      const note = stock ? stock.dataset.note : '';
      if (errEl) errEl.hidden = true;

      if (!v) {
        if (buy) buy.hidden = true;
        if (buyNow) buyNow.hidden = true;
        if (notify) notify.hidden = true;
        if (stock) { stock.className = 'stock out'; stock.innerHTML = '<i></i> Šio derinio nėra'; }
        if (stickyBtn) { stickyBtn.disabled = true; stickyBtn.textContent = 'Neprieinama'; }
        return;
      }
      current = v;
      if (idInput) idInput.value = v.id;
      if (variants.length > 1 && sec.dataset.url) {
        try { history.replaceState({}, '', sec.dataset.url + '?variant=' + v.id); } catch (e) {}
      }
      if (priceEl) {
        let h = `<span class="now">${money(v.price)}</span>`;
        if (v.compare > v.price) h += `<span class="was">${money(v.compare)}</span><span class="save">Sutaupote ${money(v.compare - v.price)}</span>`;
        priceEl.innerHTML = h;
      }
      const badges = sec.querySelector('[data-badges]');
      if (badges) {
        let sale = badges.querySelector('.badge.sale');
        const d = v.compare > v.price ? Math.round((v.compare - v.price) * 100 / v.compare) : 0;
        if (d && !sale) { sale = document.createElement('span'); sale.className = 'badge sale'; badges.prepend(sale); }
        if (sale) { if (d) sale.textContent = '−' + d + '%'; else sale.remove(); }
      }
      const low = v.available && v.managed && v.qty > 0 && v.qty <= (meta.lowStock || 5);
      if (stock) {
        stock.className = 'stock' + (!v.available ? ' out' : low ? ' low' : '');
        const tail = note ? ' · ' + note : '';
        stock.innerHTML = !v.available ? '<i></i> Išparduota' : low ? `<i></i> <b>Liko tik ${v.qty} vnt.!</b>${tail}` : `<i></i> Yra sandėlyje${tail}`;
      }
      if (buy) buy.hidden = !v.available;
      if (buyNow) buyNow.hidden = !v.available;
      if (notify) {
        notify.hidden = v.available;
        const body = notify.querySelector('[data-notify-body]');
        if (body) body.value = `Pranešti, kai atsiras: ${meta.title || ''} – ${v.title} – ${(meta.shopUrl || '') + v.url}`;
      }
      if (qtyInput) {
        if (v.managed && v.deny && v.qty > 0) qtyInput.max = v.qty; else qtyInput.removeAttribute('max');
        if (qtyInput.max && +qtyInput.value > +qtyInput.max) qtyInput.value = qtyInput.max;
      }
      const sp = sec.querySelector('[data-sticky-price]');
      if (sp) sp.textContent = money(v.price);
      if (stickyBtn) { stickyBtn.disabled = !v.available; stickyBtn.textContent = v.available ? 'Į krepšelį' : 'Išparduota'; }
      showMedia(v.media);
    }

    // Variantų pasirinkimas
    groups.forEach((g, i) => g.addEventListener('click', e => {
      const b = e.target.closest('.size'); if (!b) return;
      g.querySelectorAll('.size').forEach(x => { x.classList.toggle('on', x === b); x.setAttribute('aria-checked', x === b ? 'true' : 'false'); });
      if (labels[i]) labels[i].textContent = b.dataset.value;
      markAvailability();
      render(findVariant(selected()));
    }));
    if (groups.length) markAvailability();

    // Galerija
    sec.querySelectorAll('.thumb').forEach(t => t.addEventListener('click', () => showMedia(t.dataset.mediaId)));

    // Priartinimas pele (kompiuteryje) ir peržiūra per visą ekraną (paspaudus)
    const fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    const hiRes = pm => {
      const img = pm.querySelector('img');
      if (img && pm.dataset.zoomSrc && !pm.dataset.zoomLoaded) {
        pm.dataset.zoomLoaded = '1';
        img.removeAttribute('srcset'); img.removeAttribute('sizes');
        img.src = pm.dataset.zoomSrc;
      }
      return img;
    };
    sec.querySelectorAll('.pm.zoomable').forEach(pm => {
      if (fine) {
        pm.addEventListener('mouseenter', () => { hiRes(pm); pm.classList.add('zooming'); });
        pm.addEventListener('mousemove', e => {
          const img = pm.querySelector('img'); if (!img) return;
          const r = pm.getBoundingClientRect();
          img.style.transformOrigin = `${((e.clientX - r.left) / r.width) * 100}% ${((e.clientY - r.top) / r.height) * 100}%`;
        });
        pm.addEventListener('mouseleave', () => {
          pm.classList.remove('zooming');
          const img = pm.querySelector('img'); if (img) img.style.transformOrigin = '50% 50%';
        });
      }
      pm.addEventListener('click', () => openLightbox(pm));
    });

    let lb, lbImg, lbList = [], lbIdx = 0;
    function lbShow(i) {
      lbIdx = (i + lbList.length) % lbList.length;
      lbImg.src = lbList[lbIdx].dataset.zoomSrc;
      lbImg.alt = (lbList[lbIdx].querySelector('img') || {}).alt || '';
    }
    function closeLightbox() { if (lb) { lb.classList.remove('open'); document.documentElement.style.overflow = ''; } }
    function openLightbox(pm) {
      lbList = [...sec.querySelectorAll('.pm.zoomable')];
      if (!lbList.length) return;
      if (!lb) {
        lb = document.createElement('div');
        lb.className = 'lightbox'; lb.setAttribute('role', 'dialog'); lb.setAttribute('aria-modal', 'true'); lb.setAttribute('aria-label', 'Nuotraukos peržiūra');
        lb.innerHTML = '<img alt=""><button type="button" class="lb-close" aria-label="Uždaryti">×</button>' +
          (lbList.length > 1 ? '<button type="button" class="lb-nav lb-prev" aria-label="Ankstesnė">‹</button><button type="button" class="lb-nav lb-next" aria-label="Kita">›</button>' : '');
        document.body.appendChild(lb);
        lbImg = lb.querySelector('img');
        lb.addEventListener('click', e => {
          if (e.target.closest('.lb-prev')) return lbShow(lbIdx - 1);
          if (e.target.closest('.lb-next')) return lbShow(lbIdx + 1);
          if (e.target === lb || e.target.closest('.lb-close')) closeLightbox();
        });
        document.addEventListener('keydown', e => {
          if (!lb.classList.contains('open')) return;
          if (e.key === 'Escape') closeLightbox();
          if (e.key === 'ArrowLeft') lbShow(lbIdx - 1);
          if (e.key === 'ArrowRight') lbShow(lbIdx + 1);
        });
      }
      lbShow(Math.max(0, lbList.indexOf(pm)));
      lb.classList.add('open');
      document.documentElement.style.overflow = 'hidden';
      lb.querySelector('.lb-close').focus();
    }

    // Kiekis
    if (form) form.addEventListener('click', e => {
      const b = e.target.closest('[data-qty]'); if (!b || !qtyInput) return;
      const max = qtyInput.max ? +qtyInput.max : 999;
      qtyInput.value = Math.min(max, Math.max(1, (+qtyInput.value || 1) + (+b.dataset.qty)));
    });

    // Į krepšelį
    const showErr = e => { if (errEl) { errEl.textContent = errText(e); errEl.hidden = false; } };
    if (form) form.addEventListener('submit', e => {
      e.preventDefault();
      if (!current || !current.available) return;
      if (addBtn) addBtn.disabled = true;
      cartAdd([{ id: current.id, quantity: Math.max(1, +(qtyInput && qtyInput.value) || 1) }])
        .then(() => { done(addBtn); if (stickyBtn) done(stickyBtn); })
        .catch(showErr)
        .finally(() => { if (addBtn) addBtn.disabled = false; });
    });

    // Pirkti dabar
    const buyNow = sec.querySelector('[data-buy-now]');
    if (buyNow) buyNow.addEventListener('click', () => {
      if (!current || !current.available) return;
      buyNow.disabled = true;
      cartAdd([{ id: current.id, quantity: Math.max(1, +(qtyInput && qtyInput.value) || 1) }], { open: false })
        .then(() => { setTimeout(() => { location.href = checkoutUrl(); }, 450); })
        .catch(e => { showErr(e); buyNow.disabled = false; });
    });

    // Lipnus mygtukas telefone
    if (stickyBtn && form) stickyBtn.addEventListener('click', () => {
      if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true }));
    });
    const anchor = sec.querySelector('[data-price]') || form;
    if (sticky && anchor && 'IntersectionObserver' in window) {
      new IntersectionObserver(([en]) => {
        const show = !en.isIntersecting && en.boundingClientRect.top < 0;
        sticky.classList.toggle('show', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      }).observe(anchor);
    }

    // Po „Pranešti, kai atsiras“ formos išsiuntimo
    if (/contact_posted=true/.test(location.search)) {
      sec.querySelectorAll('[data-notify]').forEach(n => { if (n.querySelector('.notify-ok')) n.hidden = false; });
    }

    // Neseniai žiūrėtos
    const rec = () => { if (T().recent && T().recent.push) T().recent.push(sec.dataset.handle); };
    if (T().recent) rec(); else document.addEventListener('DOMContentLoaded', rec);
  }

  /* ---------------- Dažnai perkama kartu ---------------- */
  function initFbt(sec) {
    if (sec.dataset.ready) return;
    sec.dataset.ready = '1';
    const list = sec.querySelector('[data-fbt-list]');
    const wire = () => {
      const boxes = [...sec.querySelectorAll('.fbt-item input[data-variant-id]')];
      const total = sec.querySelector('[data-fbt-total]');
      const count = sec.querySelector('[data-fbt-count]');
      const btn = sec.querySelector('[data-fbt-add]');
      const upd = () => {
        const on = boxes.filter(b => b.checked), k = on.length;
        if (total) total.textContent = money(on.reduce((a, b) => a + (+b.dataset.price || 0), 0));
        if (count) count.textContent = k + (k === 1 ? ' prekė' : (k % 10 === 0 || (k % 100 > 10 && k % 100 < 20)) ? ' prekių' : ' prekės');
        if (btn) { btn.disabled = !k; btn.textContent = k === boxes.length ? 'Pridėti visas į krepšelį' : 'Pridėti pasirinktas į krepšelį'; }
      };
      boxes.forEach(b => b.addEventListener('change', upd));
      upd();
      if (btn) btn.addEventListener('click', () => {
        const items = boxes.filter(b => b.checked).map(b => ({ id: +b.dataset.variantId, quantity: 1 }));
        if (!items.length) return;
        btn.disabled = true;
        cartAdd(items).then(() => done(btn)).catch(e => alert(errText(e))).finally(() => { btn.disabled = false; });
      });
    };
    if (!sec.dataset.url) return;
    fetch(sec.dataset.url).then(r => r.text()).then(html => {
      const recs = parse(html).querySelector('[data-fbt-recs]');
      const items = recs ? recs.querySelectorAll('.fbt-item') : [];
      if (!items.length || !list) return;
      items.forEach(it => {
        const plus = document.createElement('span');
        plus.className = 'fbt-plus'; plus.setAttribute('aria-hidden', 'true'); plus.textContent = '+';
        list.appendChild(plus);
        list.appendChild(it);
      });
      sec.hidden = false;
      wire();
    }).catch(() => {});
  }

  /* ---------------- Jums taip pat gali patikti ---------------- */
  function initRecs(sec) {
    if (sec.dataset.ready || !sec.dataset.url) return;
    sec.dataset.ready = '1';
    fetch(sec.dataset.url).then(r => r.text()).then(html => {
      const grid = parse(html).querySelector('[data-recs-grid]');
      const target = sec.querySelector('[data-recs-grid]');
      if (grid && target && grid.querySelector('.card')) { target.innerHTML = grid.innerHTML; sec.hidden = false; }
    }).catch(() => {});
  }

  /* ---------------- Neseniai žiūrėtos ---------------- */
  function initRecent(sec) {
    if (sec.dataset.ready) return;
    sec.dataset.ready = '1';
    const go = () => {
      const list = (T().recent && T().recent.list ? T().recent.list() : []).filter(h => h && h !== sec.dataset.current);
      const limit = +sec.dataset.limit || 8;
      const row = sec.querySelector('[data-recent-row]');
      if (!list.length || !row) return;
      Promise.all(list.slice(0, limit).map(h =>
        fetch(root() + 'products/' + encodeURIComponent(h) + '?section_id=product-card-ajax')
          .then(r => (r.ok ? r.text() : ''))
          .then(html => { const c = html && parse(html).querySelector('.card'); return c ? c.outerHTML : ''; })
          .catch(() => '')
      )).then(cards => {
        const html = cards.filter(Boolean).join('');
        if (html) { row.innerHTML = html; sec.hidden = false; }
      });
    };
    if (T().recent) go(); else document.addEventListener('DOMContentLoaded', go);
  }

  /* ---------------- Dovanų kuponas ---------------- */
  function initGift(sec) {
    if (sec.dataset.ready) return;
    sec.dataset.ready = '1';
    const vEl = sec.querySelector('[data-variants]');
    const variants = vEl ? JSON.parse(vEl.textContent) : [];
    const form = document.getElementById(sec.dataset.form);
    if (!form) return;
    const $ = s => sec.querySelector(s);
    const idInput = form.querySelector('[data-variant-input]');
    const addBtn = form.querySelector('[data-add-to-cart]');
    const errEl = form.querySelector('[data-error]');
    let current = variants.find(v => String(v.id) === (idInput && idInput.value)) || variants[0];

    const setAmount = v => {
      if (!v) return;
      current = v;
      if (idInput) idInput.value = v.id;
      const short = moneyShort(v.price);
      if ($('[data-gc-amount]')) $('[data-gc-amount]').textContent = short;
      if ($('[data-amt-label]')) $('[data-amt-label]').textContent = short;
      if ($('[data-gift-price]')) $('[data-gift-price]').textContent = money(v.price);
      sec.querySelectorAll('.amt').forEach(b => b.classList.toggle('on', b.dataset.variantId === String(v.id)));
    };
    sec.querySelectorAll('.amt').forEach(b => b.addEventListener('click', () => setAmount(variants.find(v => String(v.id) === b.dataset.variantId))));

    // Dizainas
    const card = $('[data-gcard]');
    sec.querySelectorAll('.sw').forEach(s => s.addEventListener('click', () => {
      sec.querySelectorAll('.sw').forEach(x => x.classList.toggle('on', x === s));
      if (card) card.className = 'gcard ' + s.dataset.d;
      const d = form.querySelector('[data-design-input]'); if (d) d.value = s.getAttribute('aria-label');
    }));

    // Gavėjas
    const toggle = form.querySelector('[data-recipient-toggle]');
    const fields = $('[data-recipient]');
    const syncRecipient = () => {
      const on = !toggle || toggle.checked;
      if (fields) {
        fields.hidden = !on;
        fields.querySelectorAll('input,textarea').forEach(i => { if (!i.hasAttribute('data-keep')) i.disabled = !on; });
      }
      syncDate();
    };
    const toName = form.querySelector('[data-to-name]');
    const msg = form.querySelector('[data-msg]');
    const draw = () => {
      if ($('[data-gc-to]')) $('[data-gc-to]').textContent = toName && toName.value.trim() ? 'Kam: ' + toName.value.trim() : 'Jums, su meile';
      if ($('[data-gc-msg]')) $('[data-gc-msg]').textContent = msg && msg.value.trim() ? '„' + msg.value.trim() + '“' : 'Jūsų palinkėjimas atsiras čia.';
      if ($('[data-msg-count]') && msg) $('[data-msg-count]').textContent = msg.value.length;
    };
    [toName, msg].forEach(i => i && i.addEventListener('input', draw));

    // Siuntimo data
    const date = form.querySelector('[data-send-on]');
    const syncDate = () => {
      const pick = form.querySelector('input[name="gift_when"]:checked');
      const want = pick && pick.value === 'date' && (!toggle || toggle.checked);
      if (date) { date.hidden = !want; date.disabled = !want; }
    };
    if (date) {
      const d = new Date(), iso = x => new Date(x.getTime() - x.getTimezoneOffset() * 60000).toISOString().slice(0, 10);
      date.min = iso(d); const m = new Date(d); m.setDate(m.getDate() + 90); date.max = iso(m);
      if (!date.value) date.value = date.min;
    }
    form.querySelectorAll('input[name="gift_when"]').forEach(r => r.addEventListener('change', syncDate));
    const off = form.querySelector('[data-tz-offset]'); if (off) off.value = new Date().getTimezoneOffset();
    if (toggle) toggle.addEventListener('change', syncRecipient);
    syncRecipient(); draw(); setAmount(current);

    const props = () => {
      const p = {};
      form.querySelectorAll('[name^="properties["]').forEach(i => {
        if (i.disabled || (i.type === 'checkbox' && !i.checked) || i.value === '') return;
        p[i.name.slice(11, -1)] = i.value;
      });
      return p;
    };
    const valid = () => {
      if (errEl) errEl.hidden = true;
      if (toggle && !toggle.checked) return true;
      const email = form.querySelector('[data-to-email]');
      if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value.trim())) {
        if (errEl) { errEl.textContent = 'Įveskite teisingą gavėjo el. pašto adresą.'; errEl.hidden = false; }
        email.focus();
        return false;
      }
      return true;
    };
    const showErr = e => { if (errEl) { errEl.textContent = errText(e); errEl.hidden = false; } };
    form.addEventListener('submit', e => {
      e.preventDefault();
      if (!current || !current.available || !valid()) return;
      addBtn.disabled = true;
      cartAdd([{ id: current.id, quantity: 1, properties: props() }]).then(() => done(addBtn)).catch(showErr).finally(() => { addBtn.disabled = false; });
    });
    const buyNow = form.querySelector('[data-buy-now]');
    if (buyNow) buyNow.addEventListener('click', () => {
      if (!current || !current.available || !valid()) return;
      buyNow.disabled = true;
      cartAdd([{ id: current.id, quantity: 1, properties: props() }], { open: false })
        .then(() => { setTimeout(() => { location.href = checkoutUrl(); }, 450); })
        .catch(e => { showErr(e); buyNow.disabled = false; });
    });
  }

  function init(scope) {
    const s = scope || document;
    s.querySelectorAll('[data-product-section]').forEach(initProduct);
    s.querySelectorAll('[data-fbt]').forEach(initFbt);
    s.querySelectorAll('[data-recs]').forEach(initRecs);
    s.querySelectorAll('[data-recent]').forEach(initRecent);
    s.querySelectorAll('[data-gift-section]').forEach(initGift);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', e => init(e.target));
})();
